import React from 'react';
import Heading from '@tds/core-heading';
import PropTypes from 'prop-types';

import { formatPrice } from '../../../utils/utils';
import { getLocalizedStrings, getLocale } from '../../../misc';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

const OfficeInternetCopper = ({ officeInternetCopper }) => {
  const locale = getLocale();

  const {
    WLS: { _copperStaticIpSubnet1Label, _copperStaticIpSubnet5Label} 
  } = locale === 'en-US' ? EN : FR;
  const {
    quoteSummary: {
      products: { officeInternetCopper: labelOfficeInternetCopper },
      copperInternet,
      regularOffer,
      limitedTimeOffer,
      table: { qty, oneTimeCharges, monthlyCharges, total }
    }
  } = getLocalizedStrings();
  const {
    speed: {
      value: speedValue,
      qty: speedQty,
      prices: { oneTime: speedOneTime, monthly: speedMonthly } = {}
    } = {},
    staticIp: {
      value: staticIpValue,
      qty: staticIpQty,
      prices: { monthly: staticIpMonthly, oneTime: staticIpOneTime } = {}
    } = {},
    limitedTimeOffers,
    regularOffers,
    fiveYearlyPromo,
    switchCreditPromo,
    totalMonthly,
    wifiAccess,
    totalOneTime
  } = officeInternetCopper || {};

  // static ip label is returned based on user selection
  const staticIpLabelFunc = () => {
    if (staticIpValue === _copperStaticIpSubnet5Label) {
      return _copperStaticIpSubnet5Label;
    }
    else if (staticIpValue === _copperStaticIpSubnet1Label) {
      return _copperStaticIpSubnet1Label;
    }
    return 'Static Ips';
  };

  return (
    <>
      {officeInternetCopper && (
        <div style={{ overflowX: 'auto' }}>
          <Heading level="h3">{labelOfficeInternetCopper}</Heading>
          <br />
          <table>
            <thead>
              <tr>
                <th width="60%"></th>
                <th>{qty}</th>
                <th>{oneTimeCharges}</th>
                <th>{monthlyCharges}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {copperInternet} {speedValue}
                </td>
                <td>{speedQty}</td>
                <td>{formatPrice(speedOneTime)}</td>
                <td>{formatPrice(speedMonthly)}</td>
              </tr>
              {officeInternetCopper.staticIp && (
                <tr>
                <td>{staticIpLabelFunc()}</td>
                <td>{staticIpQty}</td>
                <td>{formatPrice(staticIpOneTime)}</td>
                <td>{formatPrice(staticIpMonthly)}</td>
              </tr>
              )}
              {regularOffers &&
                regularOffers.length > 0 &&
                regularOffers.map(
                  ({
                    value: roValue,
                    qty: roQty,
                    prices: { oneTime: roOneTime, monthly: roMonthly } = {}
                  }) => (
                    <tr key={`InternetCopperRegularOffer${roValue}`}>
                      <td>
                        {regularOffer}: {roValue}
                      </td>
                      <td>{roQty}</td>
                      <td>{formatPrice(roOneTime)}</td>
                      <td>{formatPrice(roMonthly)}</td>
                    </tr>
                  )
                )}
              {limitedTimeOffers &&
                limitedTimeOffers.length > 0 &&
                limitedTimeOffers.map(
                  ({
                    value: ltoValue,
                    qty: ltoQty,
                    prices: { oneTime: ltoOneTime, monthly: ltoMonthly } = {}
                  }) => (
                    <tr key={`InternetCopperLimitedTimeOffer${ltoValue}`}>
                      <td>
                        {limitedTimeOffer}: {ltoValue}
                      </td>
                      <td>{ltoQty}</td>
                      <td>{formatPrice(ltoOneTime)}</td>
                      <td>{formatPrice(ltoMonthly)}</td>
                    </tr>
                  )
                )}
              {wifiAccess &&
                wifiAccess.length > 0 &&
                wifiAccess.map(
                  ({
                    value: roValue,
                    qty: roQty,
                    prices: { oneTime: roOneTime, monthly: roMonthly } = {}
                  }) => (
                    <tr key={`WifiAccess${roValue}`}>
                      <td>
                        {`Wifi Access`}: {roValue}
                      </td>
                      <td>{roQty}</td>
                      <td>{formatPrice(roOneTime)}</td>
                      <td>{formatPrice(roMonthly)}</td>
                    </tr>
                  )
                )}
              {switchCreditPromo &&
                switchCreditPromo.length > 0 &&
                switchCreditPromo.map(
                  ({
                    value: ltoValue,
                  }) => (
                    <tr key={`switchCreditPromo${ltoValue}`}>
                      <td>
                        {'Switch Credit Promo'}:{` `}{ltoValue}
                      </td>
                    </tr>
                  )
                )}
              {fiveYearlyPromo &&
                fiveYearlyPromo.length > 0 &&
                fiveYearlyPromo.map(
                  ({
                    value: roValue,
                    qty: roQty,
                    prices: { oneTime: roOneTime, monthly: roMonthly } = {}
                  }) => (
                    <tr key={`fiveYearlyPromo${roValue}`}>
                      <td>
                        {'5 Yearly Promos'}: {roValue}
                      </td>
                      <td>{roQty}</td>
                      <td>{formatPrice(roOneTime)}</td>
                      <td>{formatPrice(roMonthly)}</td>
                    </tr>
                  )
                )}
              <tr>
                <td>{total}</td>
                <td></td>
                <td>{formatPrice(totalOneTime)}</td>
                <td>{formatPrice(totalMonthly)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

OfficeInternetCopper.defaultProps = {
  officeInternetCopper: {}
};

OfficeInternetCopper.propTypes = {
  officeInternetCopper: PropTypes.objectOf(PropTypes.any)
};

export default OfficeInternetCopper;
